import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BarChart3, Briefcase, Mail } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import Header from '../components/Header';
import Footer from '../components/Footer';

const HomePage = () => {
  const { username } = useAuth();
  const navigate = useNavigate();

  const services = [
    {
      icon: BarChart3,
      title: 'Résultats de tournois',
      desc: 'Consultez vos statistiques et performances détaillées',
      path: '/results'
    },
    {
      icon: Briefcase,
      title: 'Service 2',
      desc: 'Description du deuxième service offert',
      path: '/service/2'
    },
    {
      icon: Mail,
      title: 'Service 3',
      desc: 'Description du troisième service offert',
      path: '/service/3'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      {/* Hero Section */}
      <section id="accueil" className="bg-gradient-to-r from-blue-500 to-purple-600 text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-6xl font-bold mb-4">
            Bienvenue {username} !
          </h1>
          <button
            onClick={() => navigate('/calendar')}
            className="bg-white text-blue-600 px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition"
          >
            Voir le calendrier
          </button>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">Nos Services</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                onClick={() => navigate(service.path)}
                className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition cursor-pointer"
              >
                <service.icon className="text-blue-600 mb-4" size={48} />
                <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
                <p className="text-gray-600">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-16 bg-gray-100">
        <div className="container mx-auto px-4 max-w-2xl">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">Contact</h2>
          <div className="space-y-4">
            <input
              type="text"
              placeholder="Nom"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <input
              type="email"
              placeholder="Email"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <textarea
              placeholder="Message"
              rows="5"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            ></textarea>
            <button className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition">
              Envoyer
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HomePage;